module.exports = __webpack_public_path__ + "img/3.68750632.jpg";